/**
 * Local embedded cache storage.
 */
const STORAGE = window.localStorage

export default {

  clear () {
    STORAGE.clear()
  },

  /*
   GETTERS
  */
  get () {
    const embedded = STORAGE.getItem('embedded')
    if (embedded) {
      return JSON.parse(embedded)
    }
    return false
  },

  getData () {
    return {
      cloudId: STORAGE.getItem('embedded_cloud_id'),
      cloudUsername: STORAGE.getItem('embedded_cloud_username'),
      cloudPassword: STORAGE.getItem('embedded_cloud_password'),
      language: STORAGE.getItem('embedded_language')
    }
  },

  /*
   SETTERS
  */
  set (embedded) {
    return STORAGE.setItem('embedded', JSON.stringify(embedded))
  },

  setData (data) {
    STORAGE.setItem('embedded_cloud_id', data.cloudId)
    STORAGE.setItem('embedded_cloud_username', data.cloudUsername)
    STORAGE.setItem('embedded_cloud_password', data.cloudPassword)
    STORAGE.setItem('embedded_language', data.language)
  }
}
